import gql from 'graphql-tag'

export const BASIC_PROGRAM_DATA = `
id
title
createdAt
updatedAt
programType
images {
  url
}
videoUrl
imageUrl
user {
  id
  persona
  username
}
`

export const PROGRAM_FRAGMENT = `
  ${BASIC_PROGRAM_DATA}
  description
  tagList
  labFile
  code
  robots {
    id
    name
    legacyKey
    slug
  }
`
export const PROGRAMS_DEFINITION = gql`
  query Programs($page: Int, $pageSize: Int, $featured: Boolean) {
    programs(page: $page, pageSize: $pageSize, featured: $featured) {
      ${BASIC_PROGRAM_DATA}
    }
  }
`

export const PROGRAMS_CLASSROOM = gql`
  query programsByClassroom($page: Int, $pageSize: Int, $classroomId: Int!) {
    programsByClassroom(page: $page, pageSize: $pageSize, classroomId: $classroomId) {
      ${BASIC_PROGRAM_DATA}
    }
  }
`

export const PROGRAM_DEFINITION = gql`
  query Program($id: Int!) {
    program(id: $id) {
      ${PROGRAM_FRAGMENT}
    }
  }
`

export const UPSERT_PROGRAM = gql`
  mutation upsertProgram(
    $id: Int,
    $userId: Int!,
    $title: String,
    $description: String,
    $code: String,
    $robots: [ProductInput!],
    $programType: String,
    $labFile: Upload,
    $images: [Upload!],
    $video: Upload,
    $tagList: String
    ) {
    upsertProgram(id: $id, userId: $userId, title: $title, description: $description, code: $code, robots: $robots, programType: $programType, labFile: $labFile, images: $images, tagList: $tagList, video: $video) {
      errors
      status
      program {
        ${PROGRAM_FRAGMENT}
        user {
          username
        }
        code
      }
    }
  }
`

export const PROGRAMS_BY_FILTERS = gql`
  query ProgramsByFilters($page: Int, $pageSize: Int, $featured: Boolean, $sphero: Boolean, $title: String, $products: [String!], $types: [String!], $tags: [String!], $sortOrder: String) {
    programsByFilters(page: $page, pageSize: $pageSize, featured: $featured, sphero: $sphero, title: $title, products: $products, types: $types, tags: $tags, sortOrder: $sortOrder) {
      programs {
        ${BASIC_PROGRAM_DATA}
      }
      totalCount
    }
  }
`

export const PROGRAMS_BY_USER = gql`
  query ProgramsByUser($userId: Int!) {
    programsByUser(userId: $userId) {
      ${PROGRAM_FRAGMENT}
    }
  }
`

export const MY_PROGRAMS = gql`
  query MyPrograms($page: Int!, $pageSize: Int!) {
    myPrograms(page: $page, pageSize: $pageSize) {
      programs {
        ${BASIC_PROGRAM_DATA}
      }
      totalCount
    }
  }
`

export const MY_PROGRAMS_TITLES = gql`
  query MyPrograms($page: Int!, $pageSize: Int!) {
    myPrograms(page: $page, pageSize: $pageSize) {
      programs {
        title
      }
      totalCount
    }
  }
`

export const MY_PROGRAMS_COUNT = gql`
  query MyPrograms($page: Int!, $pageSize: Int!) {
    myPrograms(page: $page, pageSize: $pageSize) {
      totalCount
    }
  }
`

export const DELETE_PROGRAM = gql`
  mutation DeleteProgram($id: Int!) {
    deleteProgram(id: $id) {
      status
    }
  }
`

export const SHARE_PROGRAM = gql`
  mutation ShareProgram($programId: Int!, $recipientId: Int!, $recipientType: String!) {
    shareProgram(programId: $programId, recipientId: $recipientId, recipientType: $recipientType) {
      ${BASIC_PROGRAM_DATA}
    }
  }
`

export const COPY_PROGRAM = gql`
  mutation copyProgram($id: Int!, $title: String!) {
    copyProgram(id: $id, title: $title) {
      status
      program {
        ${PROGRAM_FRAGMENT}
      }
    }
  }
`

export const REMOVE_SHARE = gql`
  mutation RemoveShare($id: Int!) {
    removeShare(id: $id) {
      ${BASIC_PROGRAM_DATA}
    }
  }
`

export const REVIEW_PROGRAM = gql`
  mutation ReviewProgram($shareId: Int!, $reviewed: Boolean!) {
    markSharedProgramReviewed(shareId: $shareId, reviewed: $reviewed) {
      errors
      status
      share {
        id
        reviewedAt
        program {
          ${BASIC_PROGRAM_DATA}
        }
        user {
          id
        }
        recipient {
          __typename
          ...on User {
            id
            firstName
            lastName
            username
          }
          __typename
          ...on Classroom {
            id
            code
          }
        }
      }
    }
  }`
